import UserList from "../cmp/user/UserList";
function UserPage(){
    return <UserList/>
}
export default UserPage;